import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'auth-liveness-retry',
    templateUrl: 'liveness-retry.component.html',
    standalone: false
})
export class LivenessRetryComponent {
    @Input() public retryIconName: string;
    @Input() public retryStatus: string;
    @Input() public buttonType: 'primary' | 'secondary' | 'white' | 'text' = 'primary';
    @Output() public retry: EventEmitter<void> = new EventEmitter();
}
